import CarruselContacto from "./components/CarruselContacto";
import FormularioContacto from "./components/FormularioContacto";
import "./Contact.css";
import BanderaContacto from "./components/BanderaContacto";

export default function Contacto() {
  return (
    <div className="contacto-container">
      <CarruselContacto />
      <main className="contacto-content">
        <FormularioContacto />
        <BanderaContacto />
      </main>
    </div>
  );
}
